export default __webpack_public_path__ + "static/media/media-1.4c4ecf91.jpg";